export const DURATION_COLOR = "0.2s";
export const DURATION_LENGTH = "0.3s";

export enum Transition {
  Color = "0.2s",
  Length = "0.3s",
}

/**
 * Same as Transition but with values in milliseconds
 */
export enum TransitionMs {
  Color = 200,
  Length = 300,
}
